import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 14,
	viewBox: "0 0 17 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Arrow",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector 140",
			d: "M9.75166 12L14.998 7.00029L9.75166 2.00058",
			stroke: "#E5A500",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector 141",
			d: "M13.2449 6.99805L1.00195 6.99805",
			stroke: "#E5A500",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		})]
	})
});
export default SvgArrowRight;
